(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRoot(root){
    if(!root || root.__ayluDone) return;
    root.__ayluDone=true;

    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var small=window.matchMedia('(max-width:820px)').matches;

    root.querySelectorAll('a[data-cta]').forEach(function(a){
      a.addEventListener('click',function(){
        var n=a.getAttribute('data-cta');
        try{
          if(window.dataLayer) window.dataLayer.push({event:'click_cta_'+n});
          if(window.gtag) window.gtag('event','click_cta_'+n);
        }catch(e){}
      });
    });

    var revEls=Array.prototype.slice.call(root.querySelectorAll('.rv,.rmask'));
    if(reduce || !('IntersectionObserver' in window)){
      revEls.forEach(function(e){e.classList.add('in');});
    }else{
      var revObs=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('in');
            revObs.unobserve(entry.target);
          }
        });
      },{threshold:.12,rootMargin:'0px 0px -5% 0px'});
      revEls.forEach(function(e){revObs.observe(e);});
      root.querySelectorAll('.hero .rv,.hero .rmask').forEach(function(e){e.classList.add('in');});
    }

    root.querySelectorAll('.qa button').forEach(function(btn){
      btn.addEventListener('click',function(){
        var qa=btn.closest('.qa');
        var isOpen=qa.classList.contains('open');
        root.querySelectorAll('.qa').forEach(function(q){
          q.classList.remove('open');
          var b=q.querySelector('button');
          if(b) b.setAttribute('aria-expanded','false');
        });
        if(!isOpen){
          qa.classList.add('open');
          btn.setAttribute('aria-expanded','true');
        }
      });
    });

    var hdr=root.querySelector('.nav-shell');
    var prog=root.querySelector('.progress');
    var buybar=root.querySelector('.buybar');
    var lastY=window.scrollY;
    var raf=0;

    function update(){
      raf=0;
      var y=window.scrollY;
      var vh=window.innerHeight;
      var maxScroll=Math.max(1,document.documentElement.scrollHeight-vh);

      if(prog) prog.style.transform='scaleX('+Math.min(1,Math.max(0,y/maxScroll)).toFixed(4)+')';
      if(hdr){
        if(y>lastY && y>420) hdr.classList.add('hide');
        else hdr.classList.remove('hide');
      }
      if(buybar) buybar.classList.toggle('show',y>vh*.9);
      lastY=y;
    }

    function schedule(){
      if(!raf) raf=requestAnimationFrame(update);
    }

    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    schedule();

    root.__ayluCleanup=function(){
      window.removeEventListener('scroll',schedule);
      window.removeEventListener('resize',schedule);
      if(raf) cancelAnimationFrame(raf);
    };
  }

  function boot(){
    document.querySelectorAll('.lk-root').forEach(initRoot);
  }

  if(document.readyState!=='loading') boot();
  else document.addEventListener('DOMContentLoaded',boot,{once:true});

  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',function(ev){
    var root=ev.target && ev.target.querySelector ? ev.target.querySelector('.lk-root') : null;
    if(root && root.__ayluCleanup) root.__ayluCleanup();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* =========================================
     AYLU — DESACTIVAR CAMBIO DE FOTO EN HOVER
     Mantiene siempre visible la imagen nº1
     ========================================= */

  const disableProductHoverImage = (root = document) => {
    const galleries = [];

    if (
      root.nodeType === 1 &&
      root.matches &&
      root.matches('.product-grid-container .card-gallery')
    ) {
      galleries.push(root);
    }

    if (root.querySelectorAll) {
      root
        .querySelectorAll('.product-grid-container .card-gallery')
        .forEach((gallery) => galleries.push(gallery));
    }

    galleries.forEach((gallery) => {
      gallery.removeAttribute('on:pointerenter');
      gallery.removeAttribute('on:pointerleave');
      gallery.removeAttribute('on:mouseenter');
      gallery.removeAttribute('on:mouseleave');
    });
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      /* Productos ya presentes al cargar la página */
      disableProductHoverImage(document);

      /* Productos añadidos posteriormente por infinite scroll */
      const resultsList = document.querySelector('results-list');

      if (resultsList) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                disableProductHoverImage(node);
              }
            });
          });
        });

        observer.observe(resultsList, {
          childList: true,
          subtree: true
        });
      }
    },
    { once: true }
  );

  /*
   * Seguridad extra:
   * eliminamos cualquier comportamiento de hover
   * justo antes de que pueda ejecutarse.
   */
  document.addEventListener(
    'pointerover',
    (event) => {
      const gallery = event.target.closest?.(
        '.product-grid-container .card-gallery'
      );

      if (gallery) {
        gallery.removeAttribute('on:pointerenter');
        gallery.removeAttribute('on:pointerleave');
        gallery.removeAttribute('on:mouseenter');
        gallery.removeAttribute('on:mouseleave');
      }
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
